import { Send } from '@mui/icons-material';
import React from 'react'
import styled from 'styled-components'
import {mobile} from '../responsive'

const Container = styled.div`
  height: 40vh;
  background-color: #242F9B;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color:white;
  ${mobile({height : "50vh"})}
`;
const Title = styled.h1`
  font-size: 70px;
  margin-bottom: 15px;
  ${mobile({fontSize : "55px"})}
`;

const Description = styled.div`
  font-size: 24px;
  font-weight: 300;
  margin-bottom: 20px;
  ${mobile({textAlign : "center", fontSize:"20px"})}
  `
  const InputContainer = styled.div`
  width: 50%;
  height: 40px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgray;
  ${mobile({width : "80%"})}
`
const Input = styled.input`
  border: none;
  flex: 8;
  padding-left: 20px;
`;

const Button = styled.button`
  flex: 1;
  border: none;
  background-color: #9BA3EB;
  color: white;
`;


const Newsletter = () => {
  return (
    <Container>
        <Title>NewsLetter</Title>
        <Description>Subscribe to our NewsLetter to get latest offers and updates.</Description>
        <InputContainer>
            <Input placeholder='Your email' />
            <Button>
                <Send></Send>
            </Button>
        </InputContainer>
    </Container>
  )
}

export  default Newsletter